"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
exports.registerIconAliases = function () {
    styling_1.registerIconAlias('trash', 'delete');
    styling_1.registerIconAlias('onedrive', 'onedrivelogo');
    styling_1.registerIconAlias('alertsolid12', 'eventdatemissed12');
    styling_1.registerIconAlias('sixpointstar', '6pointstar');
    styling_1.registerIconAlias('twelvepointstar', '12pointstar');
    styling_1.registerIconAlias('toggleon', 'toggleleft');
    styling_1.registerIconAlias('toggleoff', 'toggleright');
};
exports.default = exports.registerIconAliases;
//# sourceMappingURL=iconAliases.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/~/@uifabric/icons/lib-commonjs/iconAliases.js
// module id = 1086
// module chunks = 0